import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCommissionsHistoryList extends Layout {
    layoutheaderCommissionHistory: LayoutHeader;
    sourceCommissionHistory: DataSource;
    tableCommissionHistory: Table;
}
